// @TODO, remove me
import React from 'react';
import Alert from '@material-ui/lab/Alert';
import './info.scss';

const AgilityInfo = ({ ...props }) => <Alert {...props} />;

export default AgilityInfo;
